"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mutateValues(set, get) {
    return { set: set, get: get };
}
exports.mutateValues = mutateValues;
//# sourceMappingURL=mutateValues.js.map